"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));
var _calendar = _interopRequireDefault(require("../../assets/svg/calendar"));
var _VerticalDivider = _interopRequireDefault(require("../Icons/VerticalDivider"));
var _InputRange = _interopRequireDefault(require("./InputRange"));
var _InputsDate = _interopRequireDefault(require("./InputsDate"));
var _Picker = _interopRequireDefault(require("./Picker"));
var _theme = _interopRequireDefault(require("../../theme"));
var _dates = require("../../utils/dates");
var _index = _interopRequireDefault(require("./index.style"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Datepicker = props => {
  const isDesktop = (0, _useMediaQuery.default)(_theme.default.breakpoints.up('md'));
  const classes = (0, _index.default)();
  const {
    datepickerIcon = /*#__PURE__*/_react.default.createElement(_calendar.default, null),
    datepickerEndIcon = /*#__PURE__*/_react.default.createElement(_calendar.default, null),
    dividerInputIcon = /*#__PURE__*/_react.default.createElement(_VerticalDivider.default, null),
    labelDatepicker = 'Dates',
    labelStartDate = 'Departure date',
    labelEndDate = 'Return date',
    placeholderStartDate = 'Start date',
    placeholderEndDate = 'End date',
    incomingStartDate = '2021/03/01',
    incomingEndDate = '2021/03/25',
    incomingStartDefaultDate = '2021/03/01',
    incomingEndDefaultDate = '2021/03/25',
    minAvailableDate = '2021/01/29',
    maxAvailableDate = '2021/04/25',
    resetDatesButtonLabel = 'Reset',
    submitDatesButtonLabel = 'Done',
    cancelButtonLabel = 'Cancel',
    forceSplitInputs = false,
    forceRangeInputs = false,
    onSelectedDates = () => {}
  } = props;
  const [state, setState] = (0, _react.useState)((0, _dates.buildCalendarStateObject)(incomingStartDefaultDate, incomingEndDefaultDate));
  const [anchorEl, setAnchorEl] = (0, _react.useState)(null);
  const [open, setOpen] = (0, _react.useState)(false);
  const id = open ? 'simple-popover' : undefined;
  const resetCalendar = () => {
    setState((0, _dates.buildCalendarStateObject)(incomingStartDate, incomingEndDate));
  };
  const setDates = dates => {
    if (state.startDate === null || state.endDate === null) {
      resetCalendar();
    }
    setState(dates);
    onSelectedDates(dates);
    setOpen(false);
    setAnchorEl(null);
  };
  const handleClick = event => {
    setOpen(true);
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };
  const dateInput = !isDesktop && !forceRangeInputs || forceSplitInputs ? /*#__PURE__*/_react.default.createElement(_InputsDate.default, {
    dividerInputIcon: dividerInputIcon,
    datepickerIcon: datepickerIcon,
    datepickerEndIcon: datepickerEndIcon,
    placeholderStartDate: placeholderStartDate,
    placeholderEndDate: placeholderEndDate,
    labelStartDate: labelStartDate,
    labelEndDate: labelEndDate,
    incomingStartDate: incomingStartDate,
    incomingEndDate: incomingEndDate,
    maxAvailableDate: maxAvailableDate,
    minAvailableDate: minAvailableDate,
    startDate: state.startDate,
    endDate: state.endDate,
    cancelButtonLabel: cancelButtonLabel,
    submitDatesButtonLabel: submitDatesButtonLabel,
    onDateChange: setDates,
    handleClose: handleClose,
    resetCalendar: resetCalendar
  }) : /*#__PURE__*/_react.default.createElement(_InputRange.default, {
    datepickerIcon: datepickerIcon,
    dividerInputIcon: dividerInputIcon,
    placeholderStartDate: placeholderStartDate,
    placeholderEndDate: placeholderEndDate,
    incomingStartDate: incomingStartDate,
    incomingEndDate: incomingEndDate,
    maxAvailableDate: maxAvailableDate,
    minAvailableDate: minAvailableDate,
    handleDatepicker: handleClick,
    labelDatepicker: labelDatepicker,
    startDate: state.startDate,
    endDate: state.endDate,
    cancelButtonLabel: cancelButtonLabel,
    onDateChange: setDates,
    resetCalendar: resetCalendar,
    resetDatesButtonLabel: resetDatesButtonLabel,
    submitDatesButtonLabel: submitDatesButtonLabel
  });
  return /*#__PURE__*/_react.default.createElement("div", null, dateInput, /*#__PURE__*/_react.default.createElement(_core.Popper, {
    className: classes.popup,
    id: id,
    open: open,
    anchorEl: anchorEl,
    placement: "top-end",
    disablePortal: false,
    modifiers: {
      offset: {
        offset: '40, 0'
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_core.ClickAwayListener, {
    onClickAway: handleClose
  }, /*#__PURE__*/_react.default.createElement(_Picker.default, {
    maxAvailableDate: maxAvailableDate,
    minAvailableDate: minAvailableDate,
    startDate: state.startDate,
    endDate: state.endDate,
    incomingStartDate: incomingStartDate,
    incomingEndDate: incomingEndDate,
    submitDatesButtonLabel: submitDatesButtonLabel,
    resetDatesButtonLabel: resetDatesButtonLabel,
    onDateChange: setDates,
    resetCalendar: resetCalendar
  }))));
};
var _default = exports.default = Datepicker;